<template>
	<div class="scroll-container">
		<div class="search-box">
			<input v-model="params.businessName" @input="handleSearch" placeholder="搜索商户名称" class="search-input" />
		</div>
		<div class="business-list">
			<h2>离线设备的商户列表</h2>

			<ul>
				<li v-for="business in businesses" :key="business.businessId" @click="handleBusinessClick(business)"
					class="business-item">
					<img v-if="business.logoUrl" :src="business.logoUrl" class="logo" alt="商户logo">
					<div class="business-info">
						<div class="name">{{ business.businessName }}</div>
						<div class="address">{{ business.address }}</div>
					</div>
				</li>
			</ul>
		</div>
		<div v-if="hasMore" class="loading" @click="businessList">显示更多</div>
		<div v-if="!hasMore" class="no-more">没有更多数据了</div>
		<el-drawer :wrapperClosable="true" direction="btt" :close-on-press-escape="true" title="" :visible.sync="drawer"
			:with-header="false">
			<p class="uc-p-txt">{{business.businessName}}</p>
			<p class="uc-p-txt">{{business.address}}</p>
			<p class="uc-p-txt"><el-link :href="navUrl">腾讯地图导航 </el-link></p>
			<p class="uc-p-txt"><el-link @click="gaodemap">高德地图导航</el-link></p>
			<p class="uc-p-txt"><el-link @click="baidumap">百度地图导航</el-link></p>
			<p class="uc-p-txt"><el-link :href="navUrl">{{navUrl}}</el-link></p>
		</el-drawer>
	</div>
</template>


<script>
	import {
		debounce
	} from 'lodash';
	import {
		Message
	} from 'element-ui'
	import {
		offlineDeviceNear
	} from '@/api/business'
	export default {
		data() {
			return {
				business: {}, //当前选择的商户
				navUrl: '', //导航的url
				drawer: false, //导航抽屉
				hasMore: true, //分页加载是否还有更多数据
				tencentMapKey: "5AABZ-75WAQ-ZWG52-4UR7A-7ITXE-SWFCX",
				businesses: [],
				params: {
					"businessName": "",
					"distinct": "",
					"latitude": "",
					"longitude": "",
					"pageIndex": 0,
					"pageSize": 10
				}
			};
		},
		mounted() {
			this.getCurrentPositionCoords().then((coords) => {
				console.log(coords)
				console.log(coords.lat)
				console.log(coords.lng)
				this.params.distinct = "5000"
				this.params.latitude = coords.lat.toFixed(6)
				this.params.longitude = coords.lng.toFixed(6)

				Message.info(`我的位置：${this.params.latitude},${this.params.longitude}`);
				this.businessList()
			}).catch((error) => {
				this.businessList()
				console.error('无法获取当前位置:', error);
				Message.error(`无法获取当前位置，显示默认数据， ${error.message}`);
			});
		},
		methods: {
			gaodemap() {
				//alert(`/gaode/gaodemap/${encodeURIComponent(this.business.addressLatitude)}/${encodeURIComponent(this.business.addressLongitude)}`)
				this.$router.push(
					`/gaode/gaodemap/${encodeURIComponent(this.business.addressLatitude)}/${encodeURIComponent(this.business.addressLongitude)}/${encodeURIComponent(this.business.businessName)}`
				)
			},
			baidumap() {
				//alert(`/baidu/baidu/${encodeURIComponent(this.business.addressLatitude)}/${encodeURIComponent(this.business.addressLongitude)}`)
				this.$router.push(
					`/baidu/baidumap/${encodeURIComponent(this.business.addressLatitude)}/${encodeURIComponent(this.business.addressLongitude)}/${encodeURIComponent(this.business.businessName)}`
				)
			},
			async businessList() {
				try {
					this.loading = true;
					const res = await offlineDeviceNear(this.params);
					this.businesses = [...this.businesses, ...res.data.rows];
					this.hasMore = res.data.total > this.businesses.length;
					this.params.pageIndex++;
				} catch (error) {
					console.error('加载商户列表失败:', error);
					Message.error('加载商户列表失败');
				} finally {
					this.loading = false;
				}
			},
			handleSearch: debounce(function() {
				this.params.pageIndex = 0;
				this.businesses = [];
				this.businessList();
			}, 500),
			handleBusinessClick(business) {
				this.business = business
				this.drawer = true;
				if (!this.params.latitude || !this.params.longitude) {
					Message.error('无法获取当前位置，导航不可用');
					return
				}
				this.drawer = true;				
				this.handleNavigation(business); //传递商户数据				
			},
			handleNavigation(business) {
				const isWeChat = navigator.userAgent.match(/micromessenger/i);
				if (isWeChat) {
					this.openWebMap(business); // 在微信中打开网页地图
				} else {
					this.openNativeMap(business); // 在其他浏览器中尝试打开原生地图应用
				}
			},
			openNativeMap(business) {
				const url =
					`qqmap://map/route?type=drive&from=${this.params.latitude},${this.params.longitude}&to=${business.addressLatitude},${business.addressLongitude}&referer=${this.tencentMapKey}`;

				this.navUrl = url;
				Message.info(`将尝试在微信中继续`);
			},
			openWebMap(business) {
				const url =
					`https://apis.map.qq.com/uri/v1/routeplan?type=drive&from=${this.params.latitude},${this.params.longitude}&to=${business.businessName}&tocoord=${business.addressLatitude},${business.addressLongitude}&referer=${this.tencentMapKey}`;

				this.navUrl = url;
				Message.info(`将尝试在浏览器中继续`);
			},
			isMobile() {
				return /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
					.test(navigator.userAgent);
			},
			getCurrentPositionCoords() {
				let defaultatLng = { lat: 39.9075, lng: 116.3881 }
				if (this.isMobile()) {
					return new Promise((resolve, reject) => {
						if (navigator.geolocation) {
							navigator.geolocation.getCurrentPosition(
								(position) => {
									resolve({
										lat: position.coords.latitude || defaultatLng.lat, 
										lng: position.coords.longitude || defaultatLng.lng
									});
								},
								(error) => {
									Message.error('geolocation error')
									resolve(defaultatLng);
								}
							);
						} else {
							Message.error('不支持geolocation')
							resolve(defaultatLng);
						}
					});
				} else {
					return new Promise((resolve, reject) => {
						const geolocation = new BMap.Geolocation();
						if (geolocation) {
							geolocation.getCurrentPosition(
								r => {
									console.log(r)
									if (r) {
										resolve({
											lat: r.point.lat,
											lng: r.point.lng
										});
									} else {
										reject(new Error('定位失败: '));
									}
								}, {
									enableHighAccuracy: true
								}
							);
						} else {
							console.error('浏览器不支持 BMap.Geolocation');
							reject(new Error('浏览器不支持 BMap.Geolocation'));
						}
					});
				}
			}
		}
	};
</script>


<style scoped>
	.scroll-container {
		height: 100%;
		overflow-y: auto;
	}

	.search-box {
		padding: 15px 20px;
		background: #f5f5f5;
	}

	.search-input {
		width: 100%;
		padding: 8px 15px;
		border: 1px solid #ddd;
		border-radius: 4px;
		outline: none;
	}

	.loading,
	.no-more {
		text-align: center;
		padding: 0px 10px 20px 10px;
		color: #999;
	}

	.business-list {
		padding: 0px 20px 0px 20px;
	}

	.business-item {
		display: flex;
		align-items: center;
		padding: 15px;
		margin-bottom: 10px;
		border: 1px solid #eee;
		border-radius: 4px;
		cursor: pointer;
		transition: background-color 0.3s;
	}

	.business-item:hover {
		background-color: #f5f5f5;
	}

	.logo {
		width: 50px;
		height: 50px;
		border-radius: 4px;
		margin-right: 15px;
		object-fit: cover;
	}

	.business-info {
		flex: 1;
	}

	.name {
		font-weight: bold;
		margin-bottom: 5px;
	}

	.address {
		color: #666;
		font-size: 14px;
	}
	
	.uc-p-txt{
		text-align: center; font-size: 14px;
	}
</style>